import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: {
  alias: String,
  keyName: Number,
},
  setup(__props) {

const route = useRoute()



return (_ctx: any,_cache: any) => {
  return (_unref(route).query.tab === __props.alias || (!_unref(route).query.tab && __props.keyName === 1))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : _createCommentVNode("", true)
}
}

})